import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, ReplaySubject, take } from 'rxjs';
import {
  InformationDialogData,
  ReturnData,
} from '../modules/shared/components/information-dialog/information-dialog-data';
import { InformationDialogType } from '../modules/shared/components/information-dialog/information-dialog-type';
import { InformationDialogComponent } from '../modules/shared/components/information-dialog/information-dialog.component';

/**
 * @deprecated
 * Use DialogService in src/app/modules/shared/ui-kit/dialog/ instead
 */
@Injectable({
  providedIn: 'root',
})
export class CustomDialogService {
  constructor(private _dialogService: DialogService) {}

  openDialog<T extends InformationDialogData>(params: T): Observable<ReturnData<T>> {
    let ref: DynamicDialogRef | undefined;

    const subject: ReplaySubject<ReturnData<T>> = new ReplaySubject<ReturnData<T>>(1);

    const data: T = {
      ...params,
      type: params.type ?? InformationDialogType.Warning,
      rejectable: params.rejectable ?? true,
      timeLimit: params.timeLimit ?? undefined,
      lineBreaks: params.lineBreaks ?? false,
      ignoreReadOnlyAcceptButton: params.ignoreReadOnlyAcceptButton ?? false,
      ignoreReadOnlyRejectButton: params.ignoreReadOnlyRejectButton ?? false,
      ignoreReadOnlyTertiaryButton: params.ignoreReadOnlyTertiaryButton ?? false,
    };

    ref = this._dialogService.open(InformationDialogComponent, {
      data: data,
      showHeader: false,
      contentStyle: { padding: 0, borderRadius: '0.5rem', overflow: 'hidden' },
    });

    ref?.onClose?.pipe(take(1)).subscribe((res: ReturnData<T>) => {
      subject.next(res);
      subject.complete();
      ref?.close();
      ref = undefined;
    });

    return subject;
  }
}
